export function DeriveDepartmentId(costCenter) {
  const alCostCenter = ['101104', '202000', '401030', '491030'];
  const caCostCenter = ['11040', '101045', '401065'];

  if (alCostCenter.includes(costCenter)) return 5;
  if (caCostCenter.includes(costCenter)) return 3;
  return 4;
}

export const useRuntimePermissionCheck = (
  rightsData: any,
  permission: string
): { hasPermission: boolean; hasRuntimePermission: boolean } => {
  const hasPermission = rightsData?.permissions.includes(permission);
  const hasRuntimePermission = Object.keys(rightsData?.runtimePermissions).includes(permission);

  return { hasPermission, hasRuntimePermission };
};
